import { useDeviceQueryApi } from "./useDeviceQueryApi";
var emptyAlarms = [];
export function useAlarms() {
  var queryApi = useDeviceQueryApi();
  var alarms = queryApi.useAlarms();
  return alarms ? alarms : emptyAlarms;
}